import React from 'react';


class FbLogin extends React.Component {
    onClick () {
        window.location = '/socialauth/login/facebook/';
    }

    render () {
        return (
            <div className="btn fb-login-btn" onClick={this.onClick.bind(this)}>
                <span className="fb-ico"></span>
                <span>{this.props.buttonText}</span>
            </div>
        );
    }
}

FbLogin.defaultProps = {
    buttonText: "Sign in with Facebook"
};

FbLogin.propTypes = {
    buttonText: React.PropTypes.string
};

export default FbLogin;



/** WEBPACK FOOTER **
 ** ./app/src/components/FbLogin.js
 **/